import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { AuthEffects } from './auth/auth.effects';
import { authReducer } from './auth/auth.reducer';
import { AppStoreDispatcher } from './app.state.dispatcher';
import { GameEffects } from './game/game.effects';
import { GameStoreDispatcher } from './game/game.dispatcher';
import { gameReducer } from './game/game.reducer';
import { clubReducer } from './club/club.reducer';
import { ClubStateDispatcher } from './club/club.dispatcher';
import { ClubEffects } from './club/club.effects';
import { profileReducer } from './profile/profile.reducer';
import { ProfileEffects } from './profile/profile.effects';
import { ConversationsEffects } from './conversations/conversations.effects';
import { conversationsReducer } from './conversations/conversations.reducer';
import { ConversationsStoreDispatcher } from './conversations/conversations.dispatcher';
import { FriendsListEffects } from './friendsList/friendList.effects';
import { friendsListReducer } from './friendsList/friendList.reducer';
import { FriendsListStoreDispatcher } from './friendsList/friendList.dispatcher';
import { FriendRequestsEffects } from './friendRequests/friendRequests.effects';
import { friendRequestsReducer } from './friendRequests/friendRequests.reducer';
import { FriendRequestsStoreDispatcher } from './friendRequests/friendRequests.dispatcher';
import { ConversationEffects } from './conversation/conversation.effects';
import { conversationReducer } from './conversation/conversation.reducer';
import { ConversationStoreDispatcher } from './conversation/conversation.dispatcher';
import { notificationReducer } from './notification/notification.reducer';
import { NotificationStateDispatcher } from './notification/notification.dispatcher';
import { NotificationEffects } from './notification/notification.effects';
import { gameSettingsReducer } from './gameSettings/gameSettings.reducer';
import { gameSocketReducer } from './gameSocket/gameSocket.reducer';
import { GameSocketEffects } from './gameSocket/gameSocket.effects';
import { GameHistoryStoreDispatcher } from './gameHistory/gameHistory.dispatcher';
import { NewMemberStoreDispatcher } from './newMembers/newMembers.dispatcher';
import { gameHistoryReducer } from './gameHistory/gameHistory.reducer';
import { newMembersReducer } from './newMembers/newMembers.reducer';
import { GameHistoryEffects } from './gameHistory/gameHistory.effects';
import { GameSettingsDispatcher } from './gameSettings/gameSettings.dispatcher';
import { EmoteStateDispatcher } from "./emotes/emotes.dispatcher";
import { EmotesEffects } from "./emotes/emotes.effects";
import {  emotesReducer} from './emotes/emotes.reducer';
import { loadingReducer } from './loading/loading.reducer';
import { schedulerReducer } from './scheduler/scheduler.reducer';
import { SchedulerEffects } from './scheduler/scheduler.effects';
import { clubLobbyReducer } from './clubLobby/clubLobby.reducer';
import { GameThemeSettingsDispatcher } from './gameThemeSettings/gameThemeSettings.dispatcher';
import { gameThemeSettingsReducer } from './gameThemeSettings/gameThemeSettings.reducer';
import { GameThemeSettingsEffects } from './gameThemeSettings/gameThemeSettings.effects';
import { freePlayLobbyReducer } from './freePlayLobby/freePlayLobby.reducer';
import { extModules } from 'src/app/build-specifics';
import { CryptoEffects } from './crypto/crypto.effects';
import { cryptoReducer } from './crypto/crypto.reducer';
import { chatUserInfosReducer } from './chatUserInfo/chatUserInfo.reducers';
import { socialReducer } from './social/social.reducer';
import { SocialEffects } from './social/social.effects';
import { NewMembersEffects } from './newMembers/newMembers.effect';
import { HomeLobbyEffects } from './lobby/homeLobby.effect';
import { homeLobbyReducer } from './lobby/homeLobby.reducer';
import { HomeLobbyStateDispatcher } from './lobby/homeLobby.dispatcher';
import { SoPoFirebaseModule } from '../firebase/firebase.module';

@NgModule({
    imports: [

        EffectsModule.forRoot([
            AuthEffects,
            GameEffects,
            GameHistoryEffects,
            GameSocketEffects,
            ClubEffects,
            ProfileEffects,
            ConversationsEffects,
            FriendsListEffects,
            FriendRequestsEffects,
            ConversationEffects,
            NotificationEffects,
            EmotesEffects,
            SchedulerEffects,
            GameThemeSettingsEffects,
            CryptoEffects,
            SocialEffects,
            NewMembersEffects,
            HomeLobbyEffects
        ]),

        StoreModule.forRoot({
            auth: authReducer,
            game: gameReducer,
            gameHistory: gameHistoryReducer,
            gameSettings: gameSettingsReducer,
            gameSocket: gameSocketReducer,
            club: clubReducer,
            profile: profileReducer,
            conversations: conversationsReducer,
            friendsList: friendsListReducer,
            friendRequests: friendRequestsReducer,
            conversation: conversationReducer,
            notification: notificationReducer,
            newMembers: newMembersReducer,
            emotes: emotesReducer,
            loading: loadingReducer,
            scheduler: schedulerReducer,
            clubLobby: clubLobbyReducer,
            freePlayLobby: freePlayLobbyReducer,
            gameThemeSetting: gameThemeSettingsReducer,
            crypto: cryptoReducer,
            chatUserInfos: chatUserInfosReducer,
            social: socialReducer,
            homeLobby: homeLobbyReducer
        },
        {
            runtimeChecks: {
                strictStateImmutability: false,
                strictActionImmutability: false,
                strictStateSerializability: false,
                strictActionSerializability: false,
                strictActionWithinNgZone: false,
                strictActionTypeUniqueness: false,
              },
        }
        ),

        SoPoFirebaseModule,

        extModules,
    ],
    providers: [
        AppStoreDispatcher,
        GameStoreDispatcher,
        GameHistoryStoreDispatcher,
        GameSettingsDispatcher,
        ClubStateDispatcher,
        ConversationsStoreDispatcher,
        FriendsListStoreDispatcher,
        FriendRequestsStoreDispatcher,
        ConversationStoreDispatcher,
        NotificationStateDispatcher,
        NewMemberStoreDispatcher,
        EmoteStateDispatcher,
        ClubStateDispatcher,
        GameThemeSettingsDispatcher,
        HomeLobbyStateDispatcher,
    ]
})
export class SoPoStateModule {}
